import ProductSubType from "@/models/Products/ProductSubType";

export default (val: ProductSubType) => {
    let returnVal = "Undefined";
    switch (val) {
        case ProductSubType.DepositCurrentAccount:
            returnVal = "Current Account"
            break;
        case ProductSubType.DepositFixedTerm:
            returnVal = "Fixed Term"
            break;
        case ProductSubType.DepositNoticeAccount:
            returnVal = "Notice Account"
            break;
        case ProductSubType.DepositSavingsAccount:
            returnVal = "Savings Account"
            break;
        case ProductSubType.DepositIndividualSavingsAccount:
            returnVal = "Individual Savings Account"
            break;
        case ProductSubType.LendingFixedTerm:
            returnVal = "Fixed Term"
            break;
        case ProductSubType.LendingDynamicTerm:
            returnVal = "Dynamic Term"
            break;
        case ProductSubType.LendingInterestFree:
            returnVal = "Interest Free"
            break;
        case ProductSubType.LendingRevolvingCredit:
            returnVal = "Revolving Credit"
            break;
    }
    return returnVal;
}